import i18next from 'i18next';
import { writable } from 'svelte/store';
import translation from './locales/zh-CN/translation.json';

const i18n = writable(i18next);
i18next.on('initialized', () => i18n.set(i18next));
export const initI18n = (_locale = 'zh-CN') => i18next.init({
	lng: 'zh-CN', fallbackLng: 'zh-CN',
	resources: { 'zh-CN': { translation } },
	interpolation: { escapeValue: false }
});
export default i18n;
